/**
 * UKG Schedule Tag Type IDs used when querying schedule tags.
 * These values correspond to the tagAssignmentContext in the UKG API.
 */
export const ScheduleTagType = Object.freeze({
    All: -1,
    Schedule: 2,
    Segment: 3,
});

